import { Grid } from "@mui/material";

export default function CustomGridItem({ children, sx,...props }) {
  return (
    <Grid
      item
      xs={12}
      xl={4}
      sx={{
        display: {
          xs: "flex",
          sm: "flex",
          md: "flex",
          lg: "grid",
          xl: "grid",
        },
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "column",
          lg: "unset",
          xl: "unset",
        },
        alignItems: {
          xs: "center",
          sm: "center",
          md: "center",
          lg: "unset",
          xl: "unset",
        },
        width: {
          xs: "100%",
          sm: "300px",
          md: "500px",
          lg: "100%",
          xl: "100%",
        },
        maxWidth: {
          xs: "100%",
          sm: "100%",
          md: "50%",
          lg: "fit-content",
          xl: "fit-content",
        },
        ...sx
      }}
      {...props}
    >
      {children}
    </Grid>
  );
}
